"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireWildcard(require("react"));
var React = _react;
const SvgComponent = (props, ref) => /*#__PURE__*/React.createElement("svg", (0, _extends2.default)({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  fill: "none",
  viewBox: "0 0 20 20",
  ref: ref
}, props), /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M13.378 5.59c.883-.677 2.16-.047 2.16 1.066v6.556h.762a.7.7 0 1 1 0 1.4h-3.102a.7.7 0 0 1-.002-1.4l.941-.001V6.77l-.497.382a.7.7 0 0 1-.851-1.112zM7.457 6.81l-2.032 4.864h4.056zm3.7 5.248-2.46-5.913c-.459-1.102-2.02-1.103-2.48-.002l-2.46 5.893a.7.7 0 0 0-.059.141l-.644 1.543a.7.7 0 1 0 1.292.54l.495-1.186h5.222l.493 1.185a.7.7 0 1 0 1.293-.538l-.652-1.566a1 1 0 0 0-.04-.098",
  clipRule: "evenodd"
}));
const ForwardRef = /*#__PURE__*/(0, _react.forwardRef)(SvgComponent);
var _default = ForwardRef;
exports.default = _default;
//# sourceMappingURL=AlphaNumericIcon20.js.map